import React, { useEffect } from 'react';
import { Grid } from '@mui/material';
import {
  AppContainer,
  MainContentContainer,
  BodyContainer,
  QuestionBank,
} from '../../../resources/styling/appStyle';
import { SideMenu } from '../../../components/layouts/SideMenu';
import { Header } from '../../../components/layouts/Header';
import TagList from './components/TagList';
import '../../../resources/styling/App.scss';
import QuestionList from './components/QuestionList';
import { AppButton } from '../../../resources/styling';
import { colors } from '../../../resources/theme/colors';
import AddEditQuestion from './components/AddEditQuestion';

const { mandy, pictonBlue } = colors;

export default function QuestionBankDashboard() {
  const [selectedTag, setSelectedTag] = React.useState(null);
  const [showAdd, setShowAdd] = React.useState(false);

  const renderAddModal = () =>
    showAdd && <AddEditQuestion doneEdit={setShowAdd} question={null} />;

  return (
    <AppContainer>
      <SideMenu />
      <BodyContainer>
        <Header />
        <MainContentContainer>
          <Grid container mb={2}>
            <Grid item xs={6} lg={6} md={6} sm={6}>
              <h3>Insights Questions</h3>
            </Grid>
            <Grid item xs={6} lg={6} md={6} sm={6} textAlign={'right'}>
              <AppButton color={mandy} onClick={() => setShowAdd(true)}>
                Add New Question
              </AppButton>
              {renderAddModal()}
            </Grid>
          </Grid>
          <QuestionBank>
            <Grid container spacing={0}>
              <Grid item xs={12} lg={3} md={3} sm={4}>
                <TagList
                  selectedTag={selectedTag}
                  setSelectedTag={setSelectedTag}
                />
              </Grid>

              <Grid item xs={12} lg={9} md={9} sm={8}>
                <QuestionList
                  selectedTag={selectedTag}
                  canNotEdit={false}
                ></QuestionList>
              </Grid>
            </Grid>
          </QuestionBank>
        </MainContentContainer>
      </BodyContainer>
    </AppContainer>
  );
}
